import React from 'react'
import { Field } from '../ui/field'
import { InputGroup } from '../ui/input-group'
import { Textarea, Text } from '@chakra-ui/react'
import { InputGroupInterface } from '@/entities/app/interfaces'

const TextareaGroupContent: React.FC<InputGroupInterface> = ({
	placeholder,
	label,
	rows = 6,
	name,
	register,
	errors,
	defaultValue
}) => {
	const getNestedError = (errors: any, path: string) => {
		return path.split('.').reduce((current, key) => {
			return current?.[key];
		}, errors);
	};

	const fieldError = name ? getNestedError(errors, name) : null;

	return (
		<InputGroup w='full' mt='4' mb='4'>
			<Field label={label} required labelProps={{ fontSize: 'md' }}>
				<Textarea
					placeholder={placeholder}
					rows={rows}
					p='5'
					fontSize='lg'
					outline='none'
					resize='none'
					defaultValue={defaultValue}
					{...(register && name ? register(name) : {})}
				/>
				{fieldError && (
					<Text color='red.500' fontSize='sm' mt={1}>
						{fieldError?.message || fieldError}
					</Text>
				)}
			</Field>
		</InputGroup>
	)
}

export default TextareaGroupContent
